module.exports = __webpack_public_path__ + "img/filter_btn.28ad53a5.svg";